import { compose } from 'recompose';
import { creditNoteAPi,jvApi,ledgerApi } from '../../common/base.api';
import CreditNoteDetail from './CreditNoteDetail';
import apiInterceptor from '../../../api/interceptor';

const CreditNoteVoucherDetail = compose(apiInterceptor({ ...creditNoteAPi , updateApi: jvApi.update, ledgerListApi:ledgerApi.getList}))(CreditNoteDetail);

export default CreditNoteVoucherDetail;
